import { createContext, useContext, useEffect, useState } from "react";
import Loader from "components/ui/Loader/Loader";
import useData from "hooks/useData";

const AccountContext = createContext([]);

export const AccountContextProvider = ({ children }) => {
  const [ user, setUser ] = useState();
  const [ profile, setProfile ] = useState();
  const [ refreshToken, setRefreshToken ] = useState();
  const [ checkingAuthentication, setCheckingAuthentication ] = useState(true);
  const { getData } = useData();

  const refresh = () => {
    setRefreshToken(Math.random());
  }

  const getCsrfToken = async () => {
    const result = await getData('session/token', undefined, false, false);
    return result.data;
  }

  useEffect(
    () => {
      const loadUser = async () => {
        let result;
        setCheckingAuthentication(true);

        try {
          result = await getData('rest/stb/user', '', true, false);
        } catch (exception) {
          console.log(exception);
        }
        if (result?.data?.id > 0) {
          setUser(result.data);
          setProfile(result.data.profile);
        } else {
          setUser(null);
          setProfile(null);
        }
        setCheckingAuthentication(false);
      }

      loadUser();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ refreshToken ]);

  if (checkingAuthentication) {
    return <Loader containerVariant={ 'fixed' }/>;
  }

  return (
    <AccountContext.Provider
      value={ {
        checkingAuthentication,
        user,
        setUser,
        profile,
        setProfile,
        getCsrfToken,
        refresh
      } }>
      { children }
    </AccountContext.Provider>
  )
}

export function useAccount() {
  return useContext(AccountContext);
}

export default AccountContextProvider;
